export const updateFormTitleFields = ({ formState, updatedFormFields }) => ({
    ...(updatedFormFields.has('titleDE') ||
        updatedFormFields.has('titleEN') ||
        updatedFormFields.has('titleCS')
        ? {
            title: {
                ...(updatedFormFields.has('titleDE')
                    ? {
                        de: formState.titleTranslations.de,
                    }
                    : {}),
                ...(updatedFormFields.has('titleEN')
                    ? {
                        en: formState.titleTranslations.en,
                    }
                    : {}),
                ...(updatedFormFields.has('titleCS')
                    ? {
                        cs: formState.titleTranslations.cs,
                    }
                    : {}),
            },
        }
        : {}),
});
export const updateFormDescriptionFields = ({ formState, updatedFormFields, }) => ({
    ...(updatedFormFields.has('descriptionDE') ||
        updatedFormFields.has('descriptionEN') ||
        updatedFormFields.has('descriptionCS')
        ? {
            description: {
                ...(updatedFormFields.has('descriptionDE')
                    ? {
                        de: formState.descriptionTranslations.de,
                    }
                    : {}),
                ...(updatedFormFields.has('descriptionEN')
                    ? {
                        en: formState.descriptionTranslations.en,
                    }
                    : {}),
                ...(updatedFormFields.has('descriptionCS')
                    ? {
                        cs: formState.descriptionTranslations.cs,
                    }
                    : {}),
            },
        }
        : {}),
});
